import { render } from "./CoBrandNova.vue?vue&type=template&id=7d841fc8&scoped=true"
import script from "./CoBrandNova.vue?vue&type=script&lang=js"
export * from "./CoBrandNova.vue?vue&type=script&lang=js"

import "./CoBrandNova.vue?vue&type=style&index=0&id=7d841fc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d841fc8"]])

export default __exports__